var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-menu-item",on:{"click":_vm.exportDocx}},[_vm._v("\n  Сформировать отчет\n")])}
var staticRenderFns = []

export { render, staticRenderFns }